// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify/extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._r-0 {\n  padding: 6px 0px;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n._r-1,\n._r-2 {\n  display: flex;\n  justify-content: space-between;\n}\n\n._r-2 {\n  font-size: 20px;\n}\n\n._r-1 {\n  font-size: 14px;\n}\n", ""]);
// Exports
export var dueLaterContainer = "_r-0";
export var dueLaterText = "_r-1";
export var dueNowText = "_r-2";
export default ___CSS_LOADER_EXPORT___;
